import Immutable from 'immutable';
import EventsConstants from '../../constants/EventsConstants';

const initialState = Immutable.fromJS({
  events: [],
  pagination: {},
  query: {},
  isFetching: false
});

export default function MyEvents(state = initialState, action) {
  switch (action.type) {
    case EventsConstants.MY_EVENTS_REQUEST: {
      return state.merge({
        isFetching: true
      });
    }

    case EventsConstants.MY_EVENTS_SUCCESS: {
      return state.merge({
        events: action.payload.events,
        query: action.query,
        isFetching: false
      });
    }

    case EventsConstants.MY_EVENTS_FAILURE: {
      return state.merge({
        isFetching: false,
        events: []
      });
    }

    default:
      return state;
  }
}
